import { Directive, Input, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { DataService } from '@app/services';

@Directive({
  selector: '[notifyMessage]'
})
export class ShowStatusDirective implements OnInit {
  @Input() notifyMessage: any;
  @Input() notifyKey: string;
  @Input() notifyClass: string;

  subscriptionNot: any; 

  constructor(
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private dataService: DataService
  ) {}

  addClass(className: string) {
    this.renderer.addClass(this.elementRef.nativeElement, className);
  }

  removeClass(className: string) {
      this.renderer.removeClass(this.elementRef.nativeElement, className);
  }

  //logique de traitement
  selectCheck(){
    if(this.notifyKey == 'pulse') this.checkStatus();
    if(this.notifyKey == 'notif') this.checkData();
  }

  //detecte les changements dans les messages
  checkData(){
    if(this.notifyMessage != null && this.notifyMessage.length){
      this.addClass(this.notifyClass);
    } else {
      this.removeClass(this.notifyClass);
    }
  }

  //detecte les changements de credit
  checkStatus(){
    if(this.notifyMessage == true){
      this.addClass(this.notifyClass);

      setTimeout(() => {
        //pub
        this.dataService.changeMessage(`${this.notifyKey}`, false);
        this.removeClass(this.notifyClass);
        this.notifyMessage = false;
      }, 3000);
    } else {
        //pub
        this.dataService.changeMessage(`${this.notifyKey}`, false);
        this.removeClass(this.notifyClass);
        this.notifyMessage = false;
    }
  }

  ngOnInit(): void {
    //changement dans le credit
    this.subscriptionNot = this.dataService.currentMessage.subscribe(
      res => {
        if(res){
          if(res[this.notifyKey]) {
            this[this.notifyKey] = res[this.notifyKey];
            this.notifyMessage = res[this.notifyKey];
            this.selectCheck();
          }
        }
      });
  }

  ngOnDestroy(): void {
    this.subscriptionNot.unsubscribe();
  }
}